window.cartRecommendation = () => {
  let isRendered = false;
  let drawer = document.querySelector('.cart-drawer');
  if (!drawer) {
    return;
  }
  let cartRecommendation = drawer.querySelector('.cart-recommendation');
  if (!cartRecommendation) {
    return;
  }
  isRendered = cartRecommendation.childElementCount !== 0;
  if (cartRecommendation && !isRendered) {
    let url = cartRecommendation.getAttribute('data-product-id');
    if (!url) {
      return;
    }
    url = `${routes.related_product_url}?section_id=cart-drawer&product_id=${url}&limit=4`;
    fetch(url).then(res => {
      return res.text();
    }).then(res => {
      const parser = new DOMParser();
      let htmlDocument = parser.parseFromString(res, 'text/html');
      let recommendationData = htmlDocument.querySelector('.cart-recommendation-wrapper');
      cartRecommendation.innerHTML = ''
      cartRecommendation.appendChild(recommendationData);
      const slider = cartRecommendation.querySelector('.cart-recommend-slider');
      if (slider && window.Swiper) {
        new Swiper(slider, {
          slidesPerView: 1.2,
          spaceBetween: 15,
          freeMode: true
        });
      }

    })
  }
}
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll('#cart-icon-bubble');
    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        if (document.body.classList.contains('template-cart')) return;
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    })
  }

  open(triggeredBy) {
    cartRecommendation();
    shippingMessageUpdate();
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    qs('.coupon-drawer-wrapper').classList.remove('open');
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, doNotOpenCart = false) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);

    });

    if (!this.querySelector(".drawer__inner-empty")) {
      this.classList.remove('is-empty');
    }

    if (doNotOpenCart) {
      return;
    }
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

// Function to render cart on page load
window.renderCartOnLoad = () => {
  const sections = ['cart-drawer', 'cart-icon-bubble'];
  const promises = sections.map(section =>
    fetch(`${window.Shopify.routes.root}?section_id=${section}`)
      .then(response => response.text())
      .then(responseText => ({ [section]: responseText }))
  );

  Promise.all(promises)
    .then(results => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        const parsedState = {
          sections: Object.assign({}, ...results)
        };
        cartDrawer.renderContents(parsedState, true);
        cartRecommendation();
      }
    })
    .catch((e) => {
      console.error('Error fetching cart sections:', e);
    });
};

// Initialize cart render on page load
  window.addEventListener('pageshow', function(event) {
  // Always re-init your JS here
  
  renderCartOnLoad(); // or any init function you need
});
customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

